import React, {useMemo} from "react";
import {AssignUserToCustomerDataGridCellKeys} from "../../../../../../core/constants/table/data-grid-column-keys";
import {DataGridColumnAlignments, DataGridColumnTypes, useDataGridSavedState} from "../../../../../../packages/data-grid";
import PartnerDataGrid from "../../../../../containers/data-grid";

const dataGridSaveConfig = {
    name: 'AssignUserToCustomerDialogCurrentCustomerSectionDataGrid',
    version: 1,
}

const AssignUserToCustomerDialogCurrentCustomerSection = ({user, countries}) => {

    const columns = useMemo(() =>
        /** @type {DataGridColumn[]}*/
        [
            {
                title: "Name",
                name: AssignUserToCustomerDataGridCellKeys.name,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
                pinned: true,
                width: 180,
            },
            {
                title: "Country",
                name: AssignUserToCustomerDataGridCellKeys.country,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: "Province",
                name: AssignUserToCustomerDataGridCellKeys.province,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: "City",
                name: AssignUserToCustomerDataGridCellKeys.city,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
            {
                title: "Address",
                name: AssignUserToCustomerDataGridCellKeys.address,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
                width: 200,
            },
            {
                title: "Postal/Zip Code",
                name: AssignUserToCustomerDataGridCellKeys.postalCode,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
        ], [])

    const [dataGridColumns] = useDataGridSavedState({
        columns: columns,
        name: dataGridSaveConfig.name,
        version: dataGridSaveConfig.version,
    });

    /**@type {DataGridRow[]}*/
    const dataGridRows = useMemo(() => {
        if (!user?.id) {
            return [];
        }
        return [{
            key: user.id,
            data: user,
            cells: {
                [AssignUserToCustomerDataGridCellKeys.name]: user?.company,
                [AssignUserToCustomerDataGridCellKeys.country]: countries?.find(c => c.id === user?.province?.countryId)?.name,
                [AssignUserToCustomerDataGridCellKeys.province]: user?.province?.name,
                [AssignUserToCustomerDataGridCellKeys.city]: user?.city,
                [AssignUserToCustomerDataGridCellKeys.address]: user?.address,
                [AssignUserToCustomerDataGridCellKeys.postalCode]: user?.postalCode,
            },
        }];
    }, [countries, user]);

    return (
        <>
            <p className={`text-md black font-weight-semi-bold text-left`}>
                Entered Customer Info:
            </p>
            <PartnerDataGrid
                {...dataGridSaveConfig}
                initialLayoutState={{
                    columns: columns,
                }}
                rows={dataGridRows}
                columns={dataGridColumns}
                hideToolbar
                hideFooter
                classNames={{
                    layout: "mt-3",
                }}
                visibleRows={1}
            />
        </>
    );
}

export default AssignUserToCustomerDialogCurrentCustomerSection;
